<template>
  <div class="manualBinding">
    <div class="barcodeBox">
      <div class="key">试管条码号</div>
      <div class="value">
        <input type="tel" placeholder="请输入试管条码号" v-model="code" @change="input" />
      </div>
      <div class="codeText">{{codeText}}</div>
    </div>
    <div class="nextBtn" v-show="btnFlag" @click="goBindingUserInfo">下一步</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      btnFlag: true,
      codeText: "",
      codeArr: [],
    };
  },
  created() {
    if (!localStorage.getItem("systemUserInfo")) {
      localStorage.setItem("redirect", location.hash.slice(1));
      this.$router.replace({
        name: "nurseLogin",
      });
    }
  },
  methods: {
    input() {
      this.codeArr.push(this.code);
      this.codeText = this.codeArr.join();
      this.code = "";
    },
    goBindingUserInfo() {
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        if (!this.codeText) {
          this.$toots("请输入试管条码号");
          return;
        }
        this.$http
          .get(`/detectBox/getSelectPage`, {
            params: {
              current: 1,
              size: 1000,
              barCode: this.codeText,
            },
          })
          .then((res) => {
            this.$store.state.closureFlag = true;
            if (res.data.code == 200) {
              let data = res.data.data;
              if (data) {
                let list = data.records;
                let arr = [];
                if (localStorage.getItem("nurseBindingUserInfoList")) {
                  try {
                    arr = JSON.parse(
                      localStorage.getItem("nurseBindingUserInfoList")
                    );
                  } catch (err) {}
                }
                for (let i = 0; i < list.length; i++) {
                  let item = list[i];
                  arr.push({
                    barCode: item.barCode,
                    userId: item.userId,
                  });
                }
                localStorage.setItem(
                  "nurseBindingUserInfoList",
                  JSON.stringify(arr)
                );
                this.$router.replace({
                  name: "nurseBindingUserInfoList",
                });
              }
            }
          });
      }
    },
  },
  mounted() {
    let winh = document.body.clientHeight; // 取窗口可视范围的高度
    window.addEventListener("resize", () => {
      if (document.body.clientHeight < winh) {
        this.btnFlag = false; //隐藏按钮
      } else {
        this.btnFlag = true; //显示按钮
      }
    });
  },
};
</script>

<style lang='less' scoped>
.manualBinding {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 110px 40px 90px 40px;
  background-color: #fff;
  height: 100%;
  .barcodeBox {
    .key {
      font-size: 36px;
      line-height: 54px;
      font-weight: 700;
    }
    .value {
      border-bottom: 1px solid #eee;
      height: 100px;
      input {
        font-size: 30px;
        margin-top: 40px;
        width: 100%;
      }
      input::placeholder {
        font-size: 30px;
        color: #cccccc;
      }
    }
  }
  .codeText {
    font-size: 28px;
    line-height: 50px;
    word-break: break-all;
  }
  .nextBtn {
    width: 100%;
    height: 88px;
    background: #1968a8;
    color: #fff;
    text-align: center;
    line-height: 88px;
    border-radius: 88px;
    font-size: 30px;
  }
}
</style>
